let confirm = {
  title: 'Confirmar Ação',
  false: 'Não',
  true: 'Sim',
  saveAlert: function (item) {
    return `O ${item} não foi salvo, deseja fechar mesmo assim ?`
  }
}

export default confirm
